import { IGetAllControleMateriaisUseCase } from "../../../presentation/useCases/read/get_all_controle_materiais_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { GetAllControleMateriaisDao } from "../../../data/daos/read/get_all_controle_materiais";

/**
 * GetAllControleMateriaisUseCase
 */

export class GetAllControleMateriaisUseCase
  extends BasePaginatedUseCase<GetAllControleMateriaisDao>
  implements IGetAllControleMateriaisUseCase
{
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllControleMateriais(
    nroMaterial?: string,
    descricao?: string,
    ativo?: string,
    page?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const response = await this.repository.getAllControleMateriaisList({
      nroMaterial,
      descricao,
      ativo,
      page,
      rowsPerPage,
    });
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
